import { AppStatic } from '../_helpers/app-static'

import { BaseClass } from './_base.model'

// import { OverviewHelper } from ''
// import { UserAuthenticationDetail } from './user-authentication-detail.model'
// import { UserRole } from './user-role.model'
// import { Attachment } from './attachment.model'
// import { ItemCollection } from './item-collection.model'

export class OverviewOptions extends BaseClass {
  klass = 'OverviewOptions'

  full: boolean

}
